
import * as React from "react"
import { attributeValueToString } from "../utils"
import { Facet } from "./Facet"

export class StringFacet extends React.Component{
  render() {
    const {
      attributeName,
      disableAdd,
      facetConfiguration,
      valueCountPairs,
      onSelectionChange,
      onClear,
      selectedFacets,
    } = this.props

    return (
      <Facet
        attributeName={attributeName}
        values={valueCountPairs.map((value) => ({
          ...value,
          ValueLabel: attributeValueToString(value.DocumentAttributeValue),
        }))}
        disableAdd={disableAdd}
        facetConfiguration={facetConfiguration}
        onSelectionChange={onSelectionChange}
        onClear={onClear}
        selectedFacets={selectedFacets}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Kendra/facets/components/StringFacet.js